import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteFetchList from './InfiniteFetchList';
import InvestorCard from './InvestorCard';

export default class InvestorsList extends Component {
  static propTypes = {
    perPage: PropTypes.number.isRequired,
    apiUrl: PropTypes.string.isRequired,
    noResultsMessage: PropTypes.string,
  }

  static defaultProps = {
    noResultsMessage: 'We couldn’t find any investors. Please refine your filters and try again.',
    directoryType: 'Companies',
  }

  renderItem = (item, key) => <InvestorCard key={key} {...item} />

  render() {
    return (
      <InfiniteFetchList
        apiUrl={this.props.apiUrl}
        perPage={this.props.perPage}
        itemRenderer={this.renderItem}
        noResultsMessage={this.props.noResultsMessage}
      />
    );
  }
}
